// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "-" + {"418":"98e44d1bca86f358f138","717":"4d0a23d4c29284aea8ed"}[chunkId] + ".js";
};